import React from "react";
import { withRouter } from "react-router-dom";
import { NavLink } from "react-router-dom";
import styled from "styled-components";
import SurgeriesTable from "components/dashboard/SurgeriesTable";

const getArchivedSurgeriesLabel = (user) => {
  const isStetson = user.email === "wbstetsonmd@gmail.com";
  if (user.role === "admin" || isStetson) {
    return "SurgTime Video Library";
  }

  if (user.role === "broadcaster") {
    return "Private Surgeries";
  }

  return "Past Surgeries";
};

const PreviousSurgeries = ({
  history,
  user,
  hideBroadcaster,
  tableTitle,
  type,
}) => {
  const onClickSurgery = (s) => {
    history.push("/app/surgery/" + s._id, { surgery: s });
    // TODO: modify API so it returns only those surgeries where user was registered
  };

  const isSelectable =
    user && (user.role === "admin" || user.email === "wbstetsonmd@gmail.com");

  let isBroadcasterVisible = true;

  if (hideBroadcaster) {
    isBroadcasterVisible = false;
  }

  const isBroadcaster = user && user.role === "broadcaster";

  return (
    <div>
      {isBroadcaster ? (
        <SplitButtonContainer>
          <SplitButton
            to="/app/archived-surgeries"
            exact
            activeClassName="active"
            className="left-button"
          >
            Published Surgeries
          </SplitButton>
          <SplitButton
            to="/app/archived-surgeries/past-my"
            activeClassName="active"
            className="right-button"
          >
            Private Surgeries
          </SplitButton>
        </SplitButtonContainer>
      ) : null}

      <SurgeriesTable
        userRole={user?.role}
        type={isBroadcaster ? "past-my-private" : type || "past"}
        title={getArchivedSurgeriesLabel(user)}
        broadcaster={isBroadcasterVisible}
        playback
        deletable
        selectable={isSelectable}
        pageSize={10}
        onEditClick={onClickSurgery}
        onProcedureClick={onClickSurgery}
      />
    </div>
  );
};

const SplitButtonContainer = styled.div`
  display: flex;
  margin-bottom: 20px;
`;

const SplitButton = styled(NavLink)`
  padding: 10px 16px;
  text-decoration: none;
  color: #495057;
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  font-weight: 500;
  transition: all 0.2s ease-in-out;
  
  &.left-button {
    border-radius: 4px 0 0 4px;
  }
  
  &.right-button {
    border-radius: 0 4px 4px 0;
    border-left: none;
  }
  
  &.active {
    background-color: #0ca3d9;
    color: white;
    border-color: #0ca3d9;
  }
  
  &:hover:not(.active) {
    background-color: #e9ecef;
  }
`;

export default withRouter(PreviousSurgeries);
